export const actions = {
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    REFRESH_TOKEN_COMPLETE: 'REFRESH_TOKEN_COMPLETE',
    ENQUEUE_FAILED_ACTION: 'ENQUEUE_FAILED_ACTION',
    DISPATCH_QUEUED_ACTIONS: 'DISPATCH_QUEUED_ACTIONS',
    SET_SCREEN_ERROR: 'SET_SCREEN_ERROR',
}

export const refreshToken = token => ({
    type: actions.REFRESH_TOKEN,
    payload: token,
})

export const refreshTokenComplete = () => ({
    type: actions.REFRESH_TOKEN_COMPLETE,
})

export const enqueueFailedAction = action => ({
    type: actions.ENQUEUE_FAILED_ACTION,
    payload: action,
})

export const dispatchQueuedActions = () => ({
    type: actions.DISPATCH_QUEUED_ACTIONS,
})

export const setScreenError = payload => ({
    type: actions.SET_SCREEN_ERROR,
    payload,
})
